export class LoanChannelDto {
    public id: string;
    public name: string;
}
export class LoanPurposeDto {
    public id: string;
    public name: string;
}
export class PipelineLoanDto {
    public loanGuid: string;
    public fields: any;
}

export class TeamBalancerDto {
    public PersonaName: string;
    public StartDate: Date;
    public EndDate: Date;
    public LoanChannelId: string;
    public loanPurposeName: string;

}

export class UnderwriterDto {
    public id: string;
    public name: string;
    public capacity: string;
}

export class TeamBalancerSubmitDto {
    public selectedUnderwriters: UnderwriterDto[];
    public selectedLoan: PipelineLoanDto;
}

export class UnderwriterTeamBalancerBatchRecordDto {
    public selectedUnderwriters: UnderwriterDto[];
    public selectedLoans: PipelineLoanDto[];
    public submitEmail: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-team-balancer/uwteambalancer.model.ts